import { BidOfferItem } from 'global/Securities/types/api/orderbook';
import {
  BidOfferItemList,
  BidOfferTotalFrequencyVolume,
  StockPriceMovement,
} from './types';
import {
  bidOfferRowQuantity,
  orderbookDataKey,
  stockPriceMovementColor,
} from './constants';
import { lotSize } from '../constant';

export const getLengthOrderbook = (
  bid: BidOfferItem = {},
  offer: BidOfferItem = {},
): number => {
  const newBid = bid || {};
  const newOffer = offer || {};

  const bidLength = Object.keys(newBid).filter((key) => key.includes('price'))?.length;
  const offerLength = Object.keys(newOffer).filter((key) =>
    key.includes('price'),
  ).length;

  const dataLength = Math.max(bidLength, offerLength);

  const dataShowedLength = dataLength <= 10 ? 10 : dataLength;
  return dataShowedLength;
};

export const getStockPriceMovement = (
  currentPrice: number,
  previousPrice: number,
): StockPriceMovement => {
  if (currentPrice === previousPrice) return StockPriceMovement.Flat;
  return currentPrice < previousPrice
    ? StockPriceMovement.Down
    : StockPriceMovement.Up;
};

export const getBidOfferList = (item: BidOfferItem, length: number): BidOfferItemList => {
  const itemList: BidOfferItemList = { frequency: [], volume: [], price: [] };
  if (!item) return itemList;

  for (let i = 1; i <= length; i += 1) {
    itemList.frequency = [
      ...itemList.frequency,
      Number(item?.[`${orderbookDataKey.frequency}${i}`]) || 0,
    ];

    itemList.price = [
      ...itemList.price,
      Number(item?.[`${orderbookDataKey.price}${i}`]) || 0,
    ];

    itemList.volume = [
      ...itemList.volume,
      (Number(item?.[`${orderbookDataKey.volume}${i}`]) || 0) / lotSize,
    ];
  }

  return itemList;
};

export const getTotalFrequencyVolume = (
  bid: Omit<BidOfferItemList, 'price'>,
  offer: Omit<BidOfferItemList, 'price'>,
  lengthRow: number,
): BidOfferTotalFrequencyVolume => {
  const frequencyVolume: BidOfferTotalFrequencyVolume = {
    bid: { frequency: 0, volume: 0 },
    offer: { frequency: 0, volume: 0 },
  };

  const { bid: newBid, offer: newOffer } = frequencyVolume;

  for (let i = 0; i < lengthRow; i += 1) {
    if (bid.frequency[i]) newBid.frequency += bid.frequency[i];
    if (bid.volume[i]) newBid.volume += bid.volume[i];

    if (offer.frequency[i]) newOffer.frequency += offer.frequency[i];
    if (offer.volume[i]) newOffer.volume += offer.volume[i];
  }

  return frequencyVolume;
};

export const getTextColor = (currentPrice: number, previousPrice: number) =>
  stockPriceMovementColor[getStockPriceMovement(currentPrice, previousPrice)];

export const formatNumber = (value: number) =>
  value.toLocaleString(undefined, { maximumFractionDigits: 0 });

export const formatCellValue = (value: number) => (!value ? '-' : formatNumber(value));
